export default __webpack_public_path__ + "static/media/Pit Fighter's Gorget.38c81222.jpg";